export function NewBodyTypeCtrl ($scope, $uibModalInstance, workshopAPI, messages) {
  
  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };
  
  $scope.save = function (form) {
    workshopAPI.post('/vehicle_body_types/quick_add', $scope.body_type, 'vehicle_body_type')
    .then(function (type) {
      $uibModalInstance.close(type);
    }, function (err) {
      messages.error(err, form);
    });
  };
  
};